<template>
    <NuxtLink :to="url" class="contents">
        <div
            class="bg-white text-black rounded-tl-sm rounded-tr-40 px-6 pt-6 pb-4"
            :style="`grid-area: title${index + 1}`"
        >
            <h3 class="job-card__title title title-md">{{ title }}</h3>
        </div>

        <div class="job-card__location bg-white text-black px-6" :style="`grid-area: location${index + 1}`">
            <span v-if="location" class="relative pb-4 pl-6">
                <i class="pi pi-map-marker absolute top-1 left-0"></i>
                {{ location }}
            </span>
        </div>

        <div
            class="job-card__details bg-white text-black px-6 pb-6 rounded-br-sm rounded-bl-40 mb-5 md:mb-10"
            :style="`grid-area: details${index + 1}`"
        >
            <div class="flex flex-col h-full justify-between">
                <div class="border-t border-gray-200 pt-4">
                    <div class="mb-2">
                        <div class="font-bold">{{ $t('jobs.properties.fields_of_expertise') }}:</div>
                        <div>{{ sector ? sector : '-' }}</div>
                    </div>

                    <div class="mb-2">
                        <div class="font-bold">{{ $t('jobs.properties.type') }}:</div>
                        <div>{{ employmentType }}</div>
                    </div>

                    <div class="mb-2">
                        <div class="font-bold">{{ $t('jobs.properties.application_deadline') }}:</div>
                        <div>{{ deadline ? deadline : '-' }}</div>
                    </div>
                </div>

                <span
                    class="p-component p-button flex justify-center mt-9"
                    :class="isFeatured ? 'p-button-help' : 'p-button-secondary p-button-dark'"
                >
                    <span class="p-button-label">{{ $t('generic.more_information') }}</span>
                </span>
            </div>
        </div>
    </NuxtLink>
</template>

<script>
export default {
    name: 'JobCard',
    props: {
        index: {
            type: Number,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        location: {
            type: String,
            required: false,
            default: null,
        },
        deadline: {
            type: String,
            required: false,
            default: null,
        },
        employmentType: {
            type: String,
            required: true,
        },
        sector: {
            type: String,
            required: false,
            default: null,
        },
        isFeatured: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style scoped></style>
